import { useEffect } from "react";
import { useParams, Navigate, Link } from "react-router-dom";
import { blogPosts } from "../data/blogData";
import Navbar from "../components/Navbar";

export const BlogDetail = () => {
  const { slug, lang } = useParams();

  const post = blogPosts.find((p) => p.es.slug === slug || p.en.slug === slug);

  useEffect(() => {
    localStorage.setItem("colorFooter", "white");
    localStorage.setItem("colorNav", "color");
    window.scrollTo(0, 0);
  }, []);

  if (!post) return <Navigate to={`/${lang}/blog`} />;

  const currentContent = post[lang] || post["en"];

  return (
    <div className="bg-white min-h-screen">
      <Navbar />

      <article className="max-w-4xl mx-auto px-4 py-12">
        {/* Navegación de regreso */}
        <div className="mb-8 mt-10">
          <Link
            to={`/${lang}/blog`}
            className="text-sm font-bold text-blue-600 flex items-center gap-2 hover:underline"
          >
            ← {lang === "es" ? "Volver al Blog" : "Back to Blog"}
          </Link>
        </div>

        <header className="mb-12">
          <h1 className="text-4xl md:text-6xl font-extrabold text-[#19235C] leading-tight mb-6">
            {currentContent.titulo}
          </h1>
          <p className="text-xl text-gray-600 leading-relaxed italic border-l-4 border-orange-500 pl-6 mb-10">
            {currentContent.descripcion}
          </p>
          <img
            src={currentContent.imagen}
            alt={currentContent.titulo}
            className="w-full h-[300px] md:h-[500px] object-cover rounded-3xl shadow-2xl"
          />
        </header>

        {/* Cuerpo del Artículo */}
        <div className="prose prose-lg prose-blue max-w-none text-gray-800">
          <div
            className="blog-content-wrapper"
            dangerouslySetInnerHTML={{ __html: currentContent.contenido }}
          />
        </div>
      </article>
    </div>
  );
};
